'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var fieldVariantStyles = {
    error: styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    border: 1px solid ", ";\n  "], ["\n    border: 1px solid ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.admin.pink;
    }),
    normal: styled.css(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n    border: 1px solid ", ";\n  "], ["\n    border: 1px solid ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.adminGreyMedium;
    }),
};
var fieldIconVariantStyles = {
    error: styled.css(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.admin.pink;
    }),
    normal: styled.css(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.fontColor;
    }),
};
var FieldStyled = styled__default.div(templateObject_7 || (templateObject_7 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  height: 48px;\n  align-items: center;\n\n  border-radius: 4px;\n  background-color: ", ";\n\n  color: ", ";\n  font-size: 16px;\n  font-family: ", ";\n  cursor: pointer;\n  padding: 0 16px;\n\n  ", ";\n\n  .field-icon {\n    margin-left: 16px;\n    flex-shrink: 0;\n\n    ", ";\n  }\n\n  ", "\n\n  ", "\n"], ["\n  display: flex;\n  height: 48px;\n  align-items: center;\n\n  border-radius: 4px;\n  background-color: ", ";\n\n  color: ",
    ";\n  font-size: 16px;\n  font-family: ", ";\n  cursor: pointer;\n  padding: 0 16px;\n\n  ", ";\n\n  .field-icon {\n    margin-left: 16px;\n    flex-shrink: 0;\n\n    ", ";\n  }\n\n  ",
    "\n\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.universal.white;
}, function (_a) {
    var isPlaceholderShown = _a.isPlaceholderShown, theme = _a.theme;
    return (isPlaceholderShown ? theme.colors.greys.adminGreyMediumAlt : theme.colors.fontColor);
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var variant = _a.variant;
    return fieldVariantStyles[variant];
}, function (_a) {
    var variant = _a.variant;
    return fieldIconVariantStyles[variant];
}, function (_a) {
    var theme = _a.theme, disabled = _a.disabled;
    return disabled
        && styled.css(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n      background-color: ", ";\n      border-color: ", ";\n      cursor: default;\n    "], ["\n      background-color: ", ";\n      border-color: ", ";\n      cursor: default;\n    "])), theme.colors.greys.adminGreyMedium, theme.colors.greys.adminGreyMedium);
}, function (_a) {
    var readOnly = _a.readOnly;
    return readOnly
        && styled.css(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject(["\n      border: none;\n      cursor: default;\n      user-select: none;\n      pointer-events: none;\n      padding-left: 0px;\n    "], ["\n      border: none;\n      cursor: default;\n      user-select: none;\n      pointer-events: none;\n      padding-left: 0px;\n    "])));
});
var Label = styled__default.span(templateObject_8 || (templateObject_8 = tslib_es6.__makeTemplateObject(["\n  margin-right: auto;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n"], ["\n  margin-right: auto;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n"])));
var RightText = styled__default.span(templateObject_9 || (templateObject_9 = tslib_es6.__makeTemplateObject(["\n  margin-right: 10px;\n  padding: 2px 8px;\n  font-size: 12px;\n  line-height: 22px;\n  font-weight: 500;\n  font-family: ", ";\n  color: ", ";\n  background-color: ", ";\n  border-radius: 16px;\n"], ["\n  margin-right: 10px;\n  padding: 2px 8px;\n  font-size: 12px;\n  line-height: 22px;\n  font-weight: 500;\n  font-family: ", ";\n  color: ", ";\n  background-color: ", ";\n  border-radius: 16px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.universal.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyDark;
});
var ExclamationMarkContainer = styled__default.div(templateObject_10 || (templateObject_10 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  margin-left: 16px;\n"], ["\n  display: flex;\n  align-items: center;\n  margin-left: 16px;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;

exports.ExclamationMarkContainer = ExclamationMarkContainer;
exports.FieldStyled = FieldStyled;
exports.Label = Label;
exports.RightText = RightText;
